<template>
    <div class="container pt-2">
        <PageTitle main="Planos" sub="Cadastrar, alterar ou deletar Planos" />
        <b-form>
            <input id="plano-id" type="hidden" v-model="plano.id" />
            <div class="row">
                <div class="col-md-8">
                    <b-form-group label="Titulo:" label-for="plano-titulo">
                        <b-form-input id="plano-titulo" type="text"
                            v-model="plano.titulo"
                            placeholder="Informe o titulo do plano."
                            :class="{ 'inputError': $v.plano.titulo.$error }"
                            class="textInput"
                            @keydown.tab="$v.plano.titulo.$touch"/>
                        <span class="error" v-if="!$v.plano.titulo.required && $v.plano.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.plano.titulo.minLength && $v.plano.titulo.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Máximo de Usuários Ativos:" label-for="plano-usr_max">
                        <b-form-input id="plano-usr_max" type="number"
                            v-model="plano.usr_max"
                            :class="{ 'inputError': $v.plano.usr_max.$error }"
                            class="textInput"
                            @keydown.tab="$v.plano.usr_max.$touch"/>
                        <span class="error" v-if="!$v.plano.usr_max.required && $v.plano.usr_max.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <label for="plano-descricao">Descrição do Plano</label>
                    <b-form-textarea id="plano-descricao" placeholder="Escreva aqui..."
                        rows="3" v-model="plano.descricao"
                        :class="{ 'inputError': $v.plano.descricao.$error }"
                        class="textInput"
                        @keydown.tab="$v.plano.descricao.$touch">
                    </b-form-textarea>
                        <span class="error" v-if="!$v.plano.descricao.required && $v.plano.descricao.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.plano.descricao.minLength && $v.plano.descricao.$error">Precisa ter no mínimo 3 caracteres!</span>
                </div>
            </div>
            <b-button variant="outline-success" @click="save" class="mt-3 botaoInput">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mt-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-planos" 
                class="text-center table table-sm" 
                :items="planos.length>0?planos:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadPlano(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-planos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-planos" 
                class="text-center table table-sm" 
                :items="planos.length>0?planos:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadPlano(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-planos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'planos',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            plano: {},
            planos: [],
            empresa: {},
            empresas: [],
            fields: [
                { key: 'id', label: 'Código', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'titulo', label: 'Título', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'usr_max', label: 'Máximo de Usuários', thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        plano: {
            titulo: {
                required,
                minLength: minLength(4)
            },
            usr_max: {
                required
            },
            descricao: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: {
        rows() {
            return this.planos.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadEmpresas() {
            const url = `${baseApiUrl}/backend/empresas.php`
            axios.get(url).then(res => {
                this.empresas = res.data.map(empresa => {
                    return { ...empresa, value: empresa.razao, text: empresa.razao }
                })
            })
        },
        loadPlanos() {
            const url = `${baseApiUrl}/backend/planos.php`
            axios.get(url).then(res => {
                this.planos = res.data
                if(this.planos.length > 0){
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.plano = {}
            this.loadPlanos()
            this.$v.plano.$reset()
        },
        save() {
            this.$v.plano.$touch()
            if(!this.$v.plano.$error){
                const method = this.plano.id ? 'put' : 'post'
                const id = this.plano.id ? `?id=${this.plano.id}` : ''
                axios[method](`${baseApiUrl}/backend/planos.php${id}`, this.plano)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Plano inserido com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Plano alterado com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(plano) {
            const sure = confirm("Deseja realmente excluir o plano?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/planos.php`
                axios.delete(url, { data: plano })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Plano excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadPlano(plano) {
            this.plano = { ...plano }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level !== 'admin') {
            this.$router.push('/')
        }
        this.loadPlanos()
        this.loadEmpresas()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.planos.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>
